var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    d: "M11.875 8.211c-.812 0-1.452.252-1.92.755-.446.48-.675 1.12-.675 1.92h.914c0-.56.126-.994.366-1.315.286-.377.709-.56 1.269-.56.48 0 .857.126 1.132.4.251.252.377.606.377 1.063 0 .32-.114.618-.332.903-.08.092-.205.23-.388.412-.618.549-1.006.983-1.155 1.326-.148.286-.217.617-.217.994v.263h.926v-.263c0-.308.069-.594.217-.845.114-.206.286-.412.526-.618.503-.445.823-.743.937-.88a2.22 2.22 0 0 0 .423-1.337c0-.686-.217-1.223-.64-1.612-.434-.411-1.029-.606-1.76-.606zm-.16 6.961c-.206 0-.366.058-.492.195a.623.623 0 0 0-.206.48c0 .194.069.354.206.491a.663.663 0 0 0 .492.195.721.721 0 0 0 .491-.195.663.663 0 0 0 .195-.491.655.655 0 0 0-.195-.48.655.655 0 0 0-.491-.195z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.8,
    stroke: "#80959D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.60da4c9b57e74e29b4021f5332dbdee9.svg";
export { ForwardRef as ReactComponent };